import React from 'react';
import {
  Box,
  Heading,
  VStack,
  HStack,
  Input,
  Flex,
} from '@chakra-ui/react';
import { format, subDays } from 'date-fns';
import CrossChainFees from '../components/fees/CrossChainFees';

const FeesPage: React.FC = () => {
  const [startDate, setStartDate] = React.useState(
    format(subDays(new Date(), 365), 'yyyy-MM')
  );
  const [endDate, setEndDate] = React.useState(
    format(new Date(), 'yyyy-MM')
  );

  return (
    <Box>
      <VStack spacing={6} align="stretch">
        <Flex
          direction={{ base: "column", md: "row" }}
          justify={{ base: "flex-start", md: "space-between" }}
          align={{ base: "stretch", md: "center" }}
          gap={4}
        >
          <Heading>Fees</Heading>
          <HStack spacing={4} justify={{ base: "center", md: "flex-end" }} flexWrap="wrap">
            <Input
              type="month"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              max={endDate}
              maxW={{ base: "150px", md: "auto" }}
            />
            <Input
              type="month"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              min={startDate}
              maxW={{ base: "150px", md: "auto" }}
            />
          </HStack>
        </Flex>

        {/* Spark fees will sit alongside the USDC/USDT section once they exist */}
        <CrossChainFees startDate={startDate} endDate={endDate} />
      </VStack>
    </Box>
  );
};

export default FeesPage;
